import type { AccessGateInviteParams, AccessGateMode } from '@francisquiniai/cuidari-core/auth'

export type View = 'home' | AccessGateMode

export type InviteResult = AccessGateInviteParams & {
  email: string
}

export function getReturnTo(): string {
  if (typeof window === 'undefined') return '/'
  const params = new URLSearchParams(window.location.search)
  const raw = params.get('return_to')
  if (!raw) return '/'
  try {
    const url = new URL(raw, window.location.origin)
    if (url.origin !== window.location.origin) return '/'
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return '/'
  }
}

export function icon(name: string) {
  return (
    <span className="material-symbols-outlined" aria-hidden="true">
      {name}
    </span>
  )
}
